import { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate, useLocation } from 'react-router-dom';

export const LuxuryHeader = ({ onContactClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 100);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navigateToSection = (path, id) => {
    if (location.pathname !== path) {
      navigate(path);
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${
        isScrolled ? 'bg-black/90 backdrop-blur-2xl' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6 py-6">
        <div className="flex items-center justify-between">

          {/* Logo */}
          <div
            onClick={() => navigate('/')}
            className="flex items-center space-x-4 cursor-pointer"
          >
            <img src="../image/MSN-One-Logo-Icon-01.svg" className="w-8 h-8" />
            <div>
              <h1 className="text-white text-xl font-bold">ONE By MSN</h1>
              <p className="text-xs text-gold-light tracking-widest">One of A KIND</p>
            </div>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex space-x-10">
            <button onClick={() => navigateToSection('/', 'residence')}>Residence</button>
            <button onClick={() => navigateToSection('/', 'amenities')}>Amenities</button>
            <button onClick={() => navigateToSection('/gallery', 'gallery')}>Gallery</button>
            <button onClick={() => navigateToSection('/', 'location')}>Location</button>
            <button onClick={() => navigateToSection('/', 'contact')}>Contact</button>
          </nav>

          {/* CTA */}
          <div className="hidden lg:block">
            <Button onClick={onContactClick}>
              <Phone className="w-4 h-4 mr-2" />
              Enquire Now
            </Button>
          </div>

          {/* Mobile Menu */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-gold-primary"
          >
            {isMobileMenuOpen ? <X /> : <Menu />}
          </button>
        </div>
      </div>
    </header>
  );
};
